import styled from 'vue-styled-components'
import { rgba } from '../../../library/lib'

const theme = {font: String, primary: String, borderRadius: Number}

const ThemedButton = styled('section', theme)`
            font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
            display: flex;
            padding: 8px;
            justify-content: center;
            font-weight: normal;
            font-size: 14px;
            background: ${props => rgba(props.primary, 0.1)};
            border-radius: ${props => props.borderRadius}px !important
            color: ${props => props.primary};
            opacity: 0.3;
            transition: opacity 0.3s;

            &.active {
              opacity: 1;
            }
          }
`

export default ThemedButton
